import React, { useRef, useState } from "react";
import styles from "./PaintingsListSection.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import FilterIcon from "components/svgs/FilterIcon";
import { useClickOutside } from "hooks/useClickOutside";
import ChevronIcon from "components/svgs/ChevronIcon";
import Checkbox from "components/checkbox/Checkbox";
import HeartIcon from "components/svgs/HeartIcon";
import { paintings } from "mockdata/paintings";

const sortBySizeOptions = [
  {
    label: "Large to Small",
    value: "large-to-small",
  },
  {
    label: "Small to Large",
    value: "small-to-large",
  },
];

const sortByDateOptions = [
  {
    label: "Oldest to Newest",
    value: "oldest-to-newest",
  },
  {
    label: "Newest to Oldest",
    value: "newest-to-oldest",
  },
];

const PaintingsListSection = () => {
  const sortBySizeDropdownRef = useRef(null);
  const [selectedSortBySize, setSelectedSortBySize] = useState(null);
  const [showSortBySizeDropdown, setShowSortBySizeDropdown] = useState(false);

  useClickOutside(sortBySizeDropdownRef, () => {
    setShowSortBySizeDropdown(false);
    setShowSortByDateDropdown(false);
  });

  const sortByDateDropdownRef = useRef(null);
  const [selectedSortByDate, setSelectedSortByDate] = useState(null);
  const [showSortByDateDropdown, setShowSortByDateDropdown] = useState(false);

  useClickOutside(sortByDateDropdownRef, () => {
    setShowSortBySizeDropdown(false);
    setShowSortByDateDropdown(false);
  });

  return (
    <div className={styles.paintingsListContainer}>
      <div className={styles.filtersSection}>
        <div className={styles.allFiltersContainer}>
          <div className={styles.filtersBtn}>
            All Filters <FilterIcon />
          </div>
        </div>

        <div className={styles.sortingContainer}>
          <div className={styles.filterItem}>
            Favorites <HeartIcon />
          </div>
          <div className={styles.sorting}>
            <div
              className={`${styles.label} ${
                showSortBySizeDropdown ? styles.open : ""
              }`}
              onClick={() => setShowSortBySizeDropdown(!showSortBySizeDropdown)}
            >
              <span>Sort by size</span>
              <ChevronIcon />
            </div>
            {showSortBySizeDropdown ? (
              <div className={styles.dropdown} ref={sortBySizeDropdownRef}>
                {sortBySizeOptions.map((option) => {
                  return (
                    <Checkbox
                      key={option.value}
                      id={option.value}
                      label={option.label}
                      isChecked={option.value === selectedSortBySize}
                      setIsChecked={() => {
                        setSelectedSortBySize((prev) =>
                          option.value === prev ? null : option.value
                        );
                        setShowSortBySizeDropdown(false);
                        setShowSortByDateDropdown(false);
                      }}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
          <div className={styles.sorting}>
            <div
              className={`${styles.label} ${
                showSortByDateDropdown ? styles.open : ""
              }`}
              onClick={() => setShowSortByDateDropdown(!showSortByDateDropdown)}
            >
              <span>Sort by price</span>
              <ChevronIcon />
            </div>
            {showSortByDateDropdown ? (
              <div className={styles.dropdown} ref={sortByDateDropdownRef}>
                {sortByDateOptions.map((option) => {
                  return (
                    <Checkbox
                      key={option.value}
                      id={option.value}
                      label={option.label}
                      isChecked={option.value === selectedSortByDate}
                      setIsChecked={() => {
                        setSelectedSortByDate((prev) =>
                          option.value === prev ? null : option.value
                        );
                        setShowSortBySizeDropdown(false);
                        setShowSortByDateDropdown(false);
                      }}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
          <div className={styles.filterItem}>Popularity</div>
          <div className={styles.filterItem}>Recommendations</div>
        </div>
      </div>
      <div className={styles.paintingsList}>
        {paintings.map((painting) => {
          return <ArtworkCard item={painting} key={painting.id} />;
        })}
      </div>
      <div className={styles.loadMore}>
        <button>Load More</button>
      </div>
    </div>
  );
};

export default PaintingsListSection;
